// extracted by mini-css-extract-plugin
export default {"container":"SweetsSection-module__container__njGXv","title":"SweetsSection-module__title__zuwan","text":"SweetsSection-module__text__LT1xz"};